import { render, staticRenderFns } from "./DocsTableFocus.vue?vue&type=template&id=e975c7d0&"
import script from "./DocsTableFocus.vue?vue&type=script&lang=js&"
export * from "./DocsTableFocus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports